import {
  IFileData,
  ISQLSeedingTranslator,
} from '@principle-theorem/practice-migrations/interfaces';
import { IProvider } from '@principle-theorem/shared';

export class CorePracticePeriodontalChartItemsTranslator
  implements ISQLSeedingTranslator, IProvider<IFileData, string[]>
{
  matchingFilenames = ['tblPerioChartItem.csv'];
  commands = [
    `sed -i 's/Row/PeriodontalRow/'`,
    `sed -i 's/Column/PeriodontalColumn/'`,
  ];

  canProvide(data: IFileData): boolean {
    return this.matchingFilenames.includes(data.fileName);
  }

  execute(data: IFileData): string[] {
    return this.commands.map((cmd) => `${cmd} ${data.filePath}`);
  }
}
